
import { useEffect, useState } from "react"
import dp from './dp.jpg'
import "./root.css"
import gyasu from './g.jpg'
import Stat from "./Stat"
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa"
import HeroSection from './HeroSection'
function RootLayout() {
  const [isLoaded, setIsLoaded] = useState(false)
  const [activeFilter, setActiveFilter] = useState("all")

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  // Portfolio categories and images
  const portfolioItems = [
    {
      id: 1,
      category: "bridal",
      title: "Bridal Portrait",
      description: "Traditional bridal makeup and jewelry",
    //image: "/images/wedding-portfolio.jpeg",
    image: 'https://scontent.fdbd1-1.fna.fbcdn.net/v/t39.30808-6/487511793_1147935700679252_451288801768525644_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=833d8c&_nc_ohc=XhoQ4rTwYkkQ7kNvwFLTyKx&_nc_oc=AdlrwNnONFZmTqfGzc59IdvOoFQF8_4Na6ra7FL7hyE8jGRHF-69mh2kfG_G9UbbosL61lBKFd4SMyy48AoM6Jw2&_nc_zt=23&_nc_ht=scontent.fdbd1-1.fna&_nc_gid=AIRSuLybBdWKIRKSJiGNqQ&oh=00_AfOFHp_T6Sx6bR8NBDgs7T-G5qQEZihqXApUTDEmXsJg1Q&oe=6867C9EB',
      size: "large",
    },
    {
      id: 2,
      category: "details",
      title: "Jewelry Details",
      description: "Intricate traditional jewelry pieces",
      image: 'https://thumbs.dreamstime.com/b/elegant-treasures-traditional-chinese-jade-jewelry-pieces-explore-timeless-elegance-exquisite-featuring-272153263.jpg',
      size: "medium",
    },
    {
      id: 3,
      category: "ceremony",
      title: "Wedding Ceremony",
      description: "Sacred wedding moments",
      image: 'https://wallpapers.com/images/hd/romantic-wedding-ceremony-png-61-bioeae2we9e48cvz.jpg',
      size: "large",
    },
    {
      id: 4,
      category: "bridal",
      title: "Bridal Elegance",
      description: "Stunning bridal attire and poses",
image:'https://scontent.fdbd1-1.fna.fbcdn.net/v/t39.30808-6/471505782_1562776977756300_9146756731439673436_n.jpg?stp=dst-jpg_p526x395_tt6&_nc_cat=109&ccb=1-7&_nc_sid=833d8c&_nc_ohc=Jore0KjZeT4Q7kNvwFbflNW&_nc_oc=AdnJiO4CAEh1uuoOkrtl87_olaoTYZ5aTpMN1dLJdCY_sr0WMR5oma4PQy0TL50wY4kRY05hp4_JD6jQ35xlSiDT&_nc_zt=23&_nc_ht=scontent.fdbd1-1.fna&_nc_gid=BgTNGPajGzZHPNFf33yX7A&oh=00_AfNK3nrKbgQyCfgjsDRq8pA8VWp1t_9ek99ulHYp7fJNUQ&oe=686800A9',
      size: "medium",
    },
    {
      id: 5,
      category: "details",
      title: "Henna Art",
      description: "Beautiful mehndi designs",
      image: 'https://i.pinimg.com/originals/51/41/f0/5141f079aab4362a8ea7f8d2fc9ea8ce.jpg',
      size: "small",
    },
    {
      id: 6,
      category: "ceremony",
      title: "Sacred Rituals",
      description: "Traditional wedding ceremonies",
      image: 'https://external.fdbd1-3.fna.fbcdn.net/emg1/v/t13/5659564252716791025?url=https%3A%2F%2Fi.ytimg.com%2Fvi%2F64jinB1wXmc%2Fmaxresdefault.jpg&fb_obo=1&utld=ytimg.com&stp=c0.5000x0.5000f_dst-jpg_flffffff_p500x261_q75_tt6&_nc_gid=E3Z8wsfjNTF2kkllrwZSyg&_nc_oc=AdninZyd0w-QLFuCscPIBH-QoC1eAZl7hFSiiimwSkFNx87h6ZJkItBrsr1B2aNkMwQ_CYpMTCvJ01SgrN9YGa5u&ccb=13-1&oh=06_Q3-0AaapHYq1MT02vWCF9svfOEGvJpdRsv3rs2tPNN9nOyb6&oe=6864054F&_nc_sid=c97757',
      size: "large",
    },
    {
      id: 7,
      category: "bridal",
      title: "Bridal Glow",
      description: "Radiant bridal moments",
      image:'https://scontent.fdbd1-2.fna.fbcdn.net/v/t39.30808-6/471394244_1562776647756333_5959039163553102629_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=833d8c&_nc_ohc=miiWWVFyHs4Q7kNvwEq5_YV&_nc_oc=AdkkKyVI6WrTjjJXD6nkFCKnYjqzhs8x0bzm_E3JmKDL6-4Kq8jiumtIqx7ymx55BQhQihbL3uU-wwPQaicBfCa3&_nc_zt=23&_nc_ht=scontent.fdbd1-2.fna&_nc_gid=FfduqPDcot8BpCgDV6OymA&oh=00_AfOsGX0q8FQtKJaV7P0NcYuPpESpkKVEc7nM4mAa1wy1Lw&oe=6867FCEB',
      size: "medium",
    },
    {
      id: 8,
      category: "details",
      title: "Traditional Elements",
      description: "Cultural wedding details",
      image: 'https://scontent.fdbd1-1.fna.fbcdn.net/v/t39.30808-6/471948857_1563276021039729_7060512376546745049_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=127cfc&_nc_ohc=v6_NcPOLe1QQ7kNvwGpYg0B&_nc_oc=AdlzevjAh5ACVK-1XnUdve-beHY1sgcMi8ge7eTGAOqX89yOx7-TPyyBgKcUm1c3yTpSxAcxM0LLVeWdm6CUiwz_&_nc_zt=23&_nc_ht=scontent.fdbd1-1.fna&_nc_gid=SNU0sDc1jbhq_qFn1jDcbQ&oh=00_AfM4OTwbJbQeb-n3pUuTs5Jz09CzpygUMKT5XysnSX5zDw&oe=6868184E',
      size: "small",
    },
  ]

  const filteredItems =
    activeFilter === "all" ? portfolioItems : portfolioItems.filter((item) => item.category === activeFilter)

  const handleFilterChange = (filter) => {
    setActiveFilter(filter)
  }

  return (
    <div className={`App ${isLoaded ? "loaded" : ""}`}>
      {/* Hero Section */}
    <HeroSection></HeroSection>

      {/* About Section */}
      <section className="about-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="about-image-container">
                <img
                  src={dp}
                  alt="Wedding Photography"
                  className="img-fluid rounded shadow-lg about-image"
                />
                <div className="image-overlay">
                  <div className="overlay-content">
                    <i className="fas fa-camera fa-3x"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content">
                <h2 className="section-title">About Yaadein Films & Photography</h2>
                <p className="lead text-dark">
                  {/* We specialize in capturing the beauty, tradition, and emotion of Indian weddings. Every moment tells a
                  story, and we're here to preserve those memories forever. */}
                At Yaadein Films & Photography, we don’t just capture moments — we preserve emotions, tell stories, and create timeless memories. Founded with a deep passion for visual storytelling, we specialize in cinematic wedding films, heartfelt pre-wedding shoots, elegant portraits, and creative event coverage.

Our name, Yaadein — which means memories — reflects our core belief: every picture holds a story, and every story deserves to be told beautifully. Whether it’s the stolen glance of a bride, the laughter of friends, or the grandeur of cultural traditions, we aim to document every detail with artistry and authenticity.
                </p>
                <div className="features">
                  <div className="feature-item">
                    <i className="fas fa-heart text-primary"></i>
                    <span className='text-dark'>Emotional Storytelling</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-gem text-primary"></i>
                    <span className='text-dark'>Traditional Elegance</span>
                  </div>
                  <div className="feature-item">
                    <i className="fas fa-star text-primary"></i>
                    <span className='text-dark'>Premium Quality</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section className="portfolio-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">Our Portfolio</h2>
              <p className="section-subtitle">A collection of our finest wedding photography moments</p>
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="filter-buttons text-center">
                <button
                  className={`btn filter-btn ${activeFilter === "all" ? "active" : ""}`}
                  onClick={() => handleFilterChange("all")}
                >
                  All
                </button>
                <button
                  className={`btn filter-btn ${activeFilter === "bridal" ? "active" : ""}`}
                  onClick={() => handleFilterChange("bridal")}
                >
                  Bridal
                </button>
                <button
                  className={`btn filter-btn ${activeFilter === "ceremony" ? "active" : ""}`}
                  onClick={() => handleFilterChange("ceremony")}
                >
                  Ceremony
                </button>
                <button
                  className={`btn filter-btn ${activeFilter === "details" ? "active" : ""}`}
                  onClick={() => handleFilterChange("details")}
                >
                  Details
                </button>
              </div>
            </div>
          </div>

          {/* Portfolio Grid */}
          <div className="row portfolio-grid">
            {filteredItems.map((item, index) => (
              <div
                key={item.id}
                className={`col-lg-${item.size === "large" ? "6" : item.size === "medium" ? "4" : "3"} col-md-6 col-sm-12 mb-4`}
              >
                <div className="portfolio-item" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="portfolio-image-container">
                    <img
                      src={item.image || "/placeholder.svg"}
                      alt={item.title}
                      className="img-fluid portfolio-image"
                    />
                    <div className="portfolio-overlay">
                      <div className="portfolio-content">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                        <button className="btn btn-light btn-sm">
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">Our Services</h2>
              <p className="section-subtitle">Complete wedding photography packages tailored to your needs</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="service-card">
                 <img src='https://shaadiwish.com/blog/wp-content/uploads/2020/09/pre-wedding-dresses-1024x682.jpg' className="service-icon"/>

                {/* <div className="service-icon">
                  <i className="fas fa-camera-retro"></i>
                </div> */}
                <h4>Pre-Wedding Shoot</h4>
                <p className='text-dark'>
                  Capture your love story before the big day with romantic and creative pre-wedding photography
                  sessions.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="service-card">
                {/* <div className="service-icon">
                  <i className="fas fa-ring"></i>
                </div> */}
             <img src='https://static.vecteezy.com/system/resources/previews/024/075/724/large_2x/portrait-of-muslim-wedding-couple-wearing-traditional-attire-generative-ai-photo.jpg' className="service-icon"/>

                <h4>Wedding Day Coverage</h4>
                <p className='text-dark'>Complete documentation of your wedding day from getting ready to the final celebration moments.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="service-card">
                {/* <div className="service-icon">
                  <i className="fas fa-heart"></i>
                </div> */}
                <img src='https://th.bing.com/th/id/R.01aacc423eea5bbf219ebe399a0ec04a?rik=cvN7We9at9QU%2bg&riu=http%3a%2f%2fwww.maharaniweddings.com%2fmedia%2fgallery%2f55347-1-orig.jpeg&ehk=drfhcNeD%2bNqcYSUI2nuwHs3g%2bdFeMX7%2bJYq9Vvp3kBA%3d&risl=&pid=ImgRaw&r=0' className="service-icon"/>

                <h4>Reception Photography</h4>
                <p className='text-dark'>Capture the joy and celebration of your reception with candid and posed photography.</p>
              </div>
            </div>

              <div class="col-lg-4 col-md-6 mb-4">
        <div class="service-card">
          <img src="https://assets-global.website-files.com/63cdd2d1d805d52f99098938/64a185fa2133a5f4177716b1_Event-coverage-video.jpg" alt="Event Coverage" class="service-icon mb-3 img-fluid rounded" />
          <h4 class="fw-bold">Event Coverage</h4>
          <p class="text-dark">We cover birthdays, engagements, and celebrations with vibrant, professional visuals.</p>
        </div>
      </div>

        <div class="col-lg-4 col-md-6 mb-4">
        <div class="service-card">
          <img src="https://stability-images-upload.s3.amazonaws.com/v1_txt2img_acd68314-b651-451b-a13c-d96366645fae.png" alt="Cinematic Edits" class="service-icon mb-3 img-fluid rounded" />
          <h4 class="fw-bold">Cinematic Edits</h4>
          <p class="text-dark">Emotionally engaging edits that turn your memories into timeless visual stories.</p>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="service-card">
          <img src="https://scontent.fdbd1-2.fna.fbcdn.net/v/t39.30808-6/501199486_4135925266734227_6983473907717027916_n.jpg?stp=cp6_dst-jpg_tt6&_nc_cat=110&ccb=1-7&_nc_sid=833d8c&_nc_ohc=TRLp6TiOJIgQ7kNvwEIyqr6&_nc_oc=AdlSQRruDcgl8FSTfrWktOTSOH5h5RuKkCdhi0qRNAVSAJaK_VP7V7m7DnYPmYIoRUcnZmbP7qiH0A2_QqtyGvL_&_nc_zt=23&_nc_ht=scontent.fdbd1-2.fna&_nc_gid=7dXdi4-T_kkI2v_zpGdMFQ&oh=00_AfPWq1injro5vsBnmjPpeEVJDVDyzbZ1AbIkJRHf3XN6YQ&oe=6867EFF6" alt="Portraits" class="service-icon mb-3 img-fluid rounded" />
          <h4 class="fw-bold">Portraits & Lifestyle</h4>
          <p class="text-dark">Character-rich, professional portraits that bring out your unique essence.</p>
        </div>
      </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="section-title">What Couples Say</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>
                    "Absolutely stunning photography! They captured every emotion and detail perfectly. Our wedding
                    album is a treasure."
                  </p>
                </div>
                <div className="testimonial-author">
                  <h5>Gyasuddin & Unknown</h5>
                  <span>Mumbai Wedding</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>
                    "Professional, creative, and so easy to work with. They made us feel comfortable and the results
                    were beyond our expectations."
                  </p>
                </div>
                <div className="testimonial-author">
                  <h5>Anita & Vikram</h5>
                  <span>Delhi Wedding</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="testimonial-card">
                <div className="testimonial-content">
                  <p>
                    "They understood our vision perfectly and delivered photographs that tell our love story
                    beautifully."
                  </p>
                </div>
                <div className="testimonial-author">
                  <h5>Taiyab & Hussainara</h5>
                  <span>Mairwa</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
<Stat></Stat>
      {/* Contact Section */}
      <section className="contact-section py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="section-title">Let's Create Magic Together</h2>
              <p className="lead">
                Ready to capture your special day? Get in touch with us to discuss your wedding photography needs.
              </p>
              <div className="contact-info">
                <div className="contact-item">
                  <i className="fas fa-phone text-primary"></i>
                  <span>+91 85210 82009</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-envelope text-primary"></i>
                  <span>alitaiyab152@gmail.com</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-map-marker-alt text-primary"></i>
                  <span>Siwan, Bihar</span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="contact-form">
                <form>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <input type="text" className="form-control" placeholder="Your Name" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <input type="email" className="form-control" placeholder="Your Email" />
                    </div>
                  </div>
                  <div className="mb-3">
                    <input type="text" className="form-control" placeholder="Wedding Date" />
                  </div>
                  <div className="mb-3">
                    <textarea className="form-control" rows="4" placeholder="Tell us about your wedding..."></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary btn-lg w-100">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

{/*reviews */}

<section className="py-5 bg-light text-center">
  <div className="container">
    <h2 className="mb-5 text-dark">Reviews</h2>
    <div className="row">

      {/* Testimonial 1 */}
      <div className="col-md-4 mb-4">
        <div className="card h-100 shadow-sm">
          <img
            src={gyasu}
            className="card-img-top"
            alt="Gyasu"
          />
          <div className="card-body">
            <h5 className="card-title">Gyasuddin Shams</h5>
            <p className="text-warning">
              ★★★★★
            </p>
            <p className="card-text">
              “Our wedding video made us cry — in the best way. Every detail was captured perfectly. We couldn’t be happier!”
            </p>
          </div>
          <div className="card-footer text-muted">Siwan, Bihar</div>
        </div>
      </div>

      {/* Testimonial 2 */}
      <div className="col-md-4 mb-4">
        <div className="card h-100 shadow-sm">
          <img
            src="https://randomuser.me/api/portraits/men/51.jpg"
            className="card-img-top"
            alt="Rohit Mehra"
          />
          <div className="card-body">
            <h5 className="card-title">Rohit & Simran</h5>
            <p className="text-warning">
              ★★★★★
            </p>
            <p className="card-text">
              “The Yaadein team is incredible. They delivered more than a video — they gave us a memory we’ll watch forever.”
            </p>
          </div>
          <div className="card-footer text-muted">Mumbai, India</div>
        </div>
      </div>

      {/* Testimonial 3 */}
      <div className="col-md-4 mb-4">
        <div className="card h-100 shadow-sm">
          <img
            src="https://randomuser.me/api/portraits/women/44.jpg"
            className="card-img-top"
            alt="Meera Patel"
          />
          <div className="card-body">
            <h5 className="card-title">Aarav & Meera</h5>
            <p className="text-warning">
              ★★★★★
            </p>
            <p className="card-text">
              “Everything felt so cinematic. The colors, music, emotions — absolutely flawless. Highly recommend!”
            </p>
          </div>
          <div className="card-footer text-muted">Delhi, India</div>
        </div>
      </div>

    </div>
  </div>
</section>


      {/* Footer */}
      <footer className="footer-section py-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="mb-0">&copy; 2024 Wedding Photography. All rights reserved.</p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="social-links">
                <a href="https://www.instagram.com/yfstudioindia?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className="social-link">
                  <FaInstagram></FaInstagram>
                </a>
                <a href="https://www.facebook.com/profile.php?id=100063884984407" className="social-link">
                  
                  <FaFacebook></FaFacebook>
                </a>
                <a href="#" className="social-link">
                  <FaTwitter></FaTwitter>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default RootLayout
